import { LoadingIcon } from "../Icon"
import React, { forwardRef } from "react"

// Button props
export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean
  href?: undefined
}

// Link props
export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  loading?: boolean
  disabled?: boolean
  href?: string
}

export const isLinkProps = (
  props: ButtonProps | LinkProps
): props is LinkProps => "href" in props && !!props.href

const _Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props: ButtonProps, ref) => {
    const { disabled, loading, children, ...restProps } = props
    return (
      <button
        ref={ref}
        aria-disabled={disabled}
        aria-busy={loading}
        disabled={disabled}
        {...restProps}
      >
        {loading && <LoadingIcon className="cob-Button__loading-icon" />}
        {children}
      </button>
    )
  }
)
_Button.displayName = "button"

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (props: LinkProps, ref) => {
    const { disabled, target, rel, loading, children, ...restProps } = props
    return (
      <a
        aria-disabled={disabled}
        data-disabled={disabled}
        aria-busy={loading}
        target={target}
        rel={target && !rel ? "noopener noreferrer" : rel}
        ref={ref}
        {...restProps}
      >
        {loading && <LoadingIcon className="cob-Button__loading-icon" />}
        {children}
      </a>
    )
  }
)
Link.displayName = "link"

const Button = Object.assign(_Button, { Link })

export default Button
